// extracted by css-extract-rspack-plugin
var _1 = "url-card-hfLvCG";
var _2 = "url-card-hfLvCG";
export { _1 as "url-card", _2 as "urlCard" }
